module.exports = __webpack_public_path__ + "static/root-canal-new-img-470b45ffdd428cb279b030833d56a53c.gif";